/* eslint-disable */
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { useRef, useState, useCallback, useEffect, Suspense } from "react";
import { useNavigate } from "react-router-dom";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./dashboard.css";
import AddIcon from "@mui/icons-material/Add";
import { trackPromise } from "react-promise-tracker";
import {
	getCurrentDateForReportGeneration,
	mongoDBDateParserToUSAFormat_v2
} from "../../../utils/commonFunctions/dates";
import DashboardGrid from "./dashboardGrid/DashboardGrid";
import SortSection from "./sortSection/SortSection";
import TabPanel from "../../shared/tabPanelComponent/TabPanel";
import a11yProps from "../../../constants/tabPanelProps/ayProps";
import { Box, Button, Chip, Paper, Tab, Tabs } from "@material-ui/core";
import { Checkbox, FormControlLabel, FormGroup, Pagination, SelectChangeEvent } from "@mui/material";
import { CATEGORY_LIST } from "../../../constants/categoryList/CategoryList";
import { api } from "../../../utils/api";
import { GROUP_LIST } from "../../../constants/groupList/GroupList";
import { filterQuery } from "../../../@types/filterQuery.types";
import SettingsIcon from "@mui/icons-material/Settings";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import { CLAIM_STATUS } from "../../../constants/claimStatus/ClaimStatus";
import { pink } from "@mui/material/colors";
import ReportGrid from "./reportGrid/ReportGrid";

const Dashboard = ({ group_index }: { group_index: number }) => {
	const group = GROUP_LIST[group_index];
	const [allClaimsMember, setAllClaimsMember] = useState<any[]>([]);
	const [hasNotes, sethasNotes] = useState<boolean>(false);
	const [checkStatusRequestedMembers, setCheckStatusRequestedMembers] = useState<any[]>([]);
	const [clousureLetterCompleted, setClousureLetterCompleted] = useState<any[]>([]);
	const [clousureLetterRequired, setClousureLetterRequired] = useState<any[]>([]);
	const [moveToHistory, setMoveToHistory] = useState<any[]>([]);
	const [paidClaims, setPaidClaims] = useState<any[]>([]);
	const [selectedRowMap, setSelectedRowMap] = useState<Map<string, number>>(new Map<string, number>());
	const [hasClickedSort, setHasClickedSort] = useState(false);
	const [tabLabel, setTabLabel] = useState(0);
	// const agGridRef = useRef<any>(null);
	const [limit, setLimit] = useState<number | null>(null);
	const [sortField, setSortField] = useState<{ field: any; order: any }>({
		field: null,
		order: null
	});
	const [paidClaimFilterSchema, setPaidClaimFilterSchema] = useState({
		claim_number: { value: null, type: null },
		patient_first_name: { value: null, type: null },
		patient_last_name: { value: null, type: null },
		date_of_service: { value: null, type: null },
		total_charge: { value: null, type: null },
		savings: { value: null, type: null },
		discount: { value: null, type: null },
		cheque_cleared: { value: null, type: null },
		cheque_mailed: { value: null, type: null },
		cheque_received: { value: null, type: null }
	});
	const [pagination, setPagination] = useState({
		currentPage: 1,
		pageCount: undefined
	});
	const [isPageChange, setIsPageChange] = useState<boolean>(false);
	const [pageState, setPageState] = useState<any>({ is_all_claims: true });
	const { currentPage, pageCount } = pagination;
	const navigate = useNavigate();

	// console.log("selectedRowMap", selectedRowMap);

	// const handleSeeDetailsClick = () => {
	// 	const focusedCell = agGridRef?.current.api.getFocusedCell();
	// 	const row = agGridRef?.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
	// 	const { data } = row;
	// 	navigate(`/idr/add-record?e=1&&id=${data._id}`);
	// };

	const handleLabelChange = useCallback((event: any, value: number) => {
		setTabLabel(value);
	}, []);

	const handleChnagePageState = useCallback(() => {
		if (tabLabel === 0) {
			setPageState({ is_all_claims: true });
		}
		if (tabLabel === 1) {
			setPageState({ is_check_status_requested: true });
		}
		if (tabLabel === 2) {
			setPageState({ is_closure_letter_completed: true });
		}
		if (tabLabel === 3) {
			setPageState({ is_closure_letter_required: true });
		}
	}, [tabLabel]);

	// const handleSelectRow = useCallback(
	// 		(rowId: string) => {
	// 			// eslint-disable-next-line arrow-parens
	// 			setSelectedRowMap((prevMap) => {
	// 				// Create a new Map for immutability
	// 				const tempMap = new Map(prevMap);
	// 				if (tempMap.has(rowId)) {
	// 					tempMap.delete(rowId);
	// 				} else {
	// 					tempMap.set(rowId, 1);
	// 				}
	// 				return tempMap; // Return the new Map as the new state
	// 			});
	// 		},
	// 		[] // Remove selectedRowMap from dependencies
	// 	);

	const handleSelectRow = useCallback(
		(rowId: any, selected?: boolean) => {
			const rowIdLength = rowId.length - 1;
			const lastRowId = rowId[rowIdLength];
			// eslint-disable-next-line arrow-parens
			if (selected == undefined) {
			} else {
				if (selected) {
					setSelectedRowMap((prevMap) => {
						// Create a new Map for immutability
						const tempMap = new Map(prevMap);
						// if (tempMap.has(lastRowId)) {
						// 	tempMap.delete(lastRowId);
						// } else {
						// 	tempMap.set(lastRowId, 1);
						// }
						// rowId.forEach((row: any) => {
						// tempMap.set(row, 1);
						// });
						tempMap.set(rowId, 1);
						// console.log("tempMap", tempMap);
						return tempMap; // Return the new Map as the new state
					});
				} else {
					setSelectedRowMap((prevMap) => {
						// Create a new Map for immutability
						const tempMap = new Map(prevMap);

						tempMap.delete(rowId);

						// console.log("tempMap", tempMap);
						return tempMap; // Return the new Map as the new state
					});
				}
			}
		},
		[] // Remove selectedRowMap from dependencies
	);

	const handleUpdateCategory = async (category: string) => {
		const idList = [];
		for (const key of selectedRowMap.keys()) {
			idList.push(key);
		}
		const payload = {
			idList: idList,
			claimCategory: category
		};
		const response = await trackPromise(api.paidClaim.updateClaimCategoryByIdList(payload));
		if (response) {
			getPaidClaimsSorted(pagination.currentPage);
			// eslint-disable-next-line arrow-parens
			setSelectedRowMap((prevMap) => {
				const tempMap = new Map(prevMap);
				tempMap.clear();
				return tempMap;
			});
		}
	};

	const handleClaimStatus = async (claimObjectId: string, claim_status: string) => {
		const user = JSON.parse(localStorage.getItem("@user") as string);

		const currentDate = getCurrentDateForReportGeneration();

		const payload = {
			claim_status: claim_status,
			updated_by: user._id,
			updated_date: currentDate
		};

		// const { claim_status, updated_by, updated_date } = req.body;
		const response = await trackPromise(api.paidClaim.editClaimStatusById(payload, claimObjectId));
		if (response) {
			getPaidClaimsSorted(pagination.currentPage);
			// eslint-disable-next-line arrow-parens
			setSelectedRowMap((prevMap) => {
				const tempMap = new Map(prevMap);
				tempMap.clear();
				return tempMap;
			});
		}
	};

	const handleClickToAddRecord = () => {
		const pathname = `/idr/add-record?gn=${group.number}`;
		navigate(pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	};

	const handleStatusChangeNotes = () => {
		sethasNotes(!hasNotes);
	};

	const handleMemberChanges = (members: any, _members: any) => {
		members.forEach((member: any) => {
			const {
				date_of_service,
				cheque_cleared,
				cheque_mailed,
				cheque_received,
				cooling_off_period,
				final_selection_of_idr_entity,
				notice_of_idr_initiation_end_of_right_to_initiate,
				notice_of_idr_initiation_received_date,
				open_negotiation_notice_end_of_right_to_initiate_on,
				open_negotiation_notice_received_date,
				open_negotiation_period_ending,
				reissued,
				selection_of_certified_idr_entity,
				selection_of_offer_and_decision,
				submission_of_offer
			} = member;
			// console.log("member", member);

			_members.push({
				...member,
				date_of_service: date_of_service ? mongoDBDateParserToUSAFormat_v2(date_of_service) : date_of_service,
				cheque_cleared: cheque_cleared ? mongoDBDateParserToUSAFormat_v2(cheque_cleared) : cheque_cleared,
				cheque_mailed: cheque_mailed ? mongoDBDateParserToUSAFormat_v2(cheque_mailed) : cheque_mailed,
				cheque_received: cheque_received ? mongoDBDateParserToUSAFormat_v2(cheque_received) : cheque_received,
				cooling_off_period: cooling_off_period
					? mongoDBDateParserToUSAFormat_v2(cooling_off_period)
					: cooling_off_period,
				final_selection_of_idr_entity: final_selection_of_idr_entity
					? mongoDBDateParserToUSAFormat_v2(final_selection_of_idr_entity)
					: final_selection_of_idr_entity,
				notice_of_idr_initiation_end_of_right_to_initiate: notice_of_idr_initiation_end_of_right_to_initiate
					? mongoDBDateParserToUSAFormat_v2(notice_of_idr_initiation_end_of_right_to_initiate)
					: notice_of_idr_initiation_end_of_right_to_initiate,
				notice_of_idr_initiation_received_date: notice_of_idr_initiation_received_date
					? mongoDBDateParserToUSAFormat_v2(notice_of_idr_initiation_received_date)
					: notice_of_idr_initiation_received_date,
				open_negotiation_notice_end_of_right_to_initiate_on: open_negotiation_notice_end_of_right_to_initiate_on
					? mongoDBDateParserToUSAFormat_v2(open_negotiation_notice_end_of_right_to_initiate_on)
					: open_negotiation_notice_end_of_right_to_initiate_on,
				open_negotiation_notice_received_date: open_negotiation_notice_received_date
					? mongoDBDateParserToUSAFormat_v2(open_negotiation_notice_received_date)
					: open_negotiation_notice_received_date,
				open_negotiation_period_ending: open_negotiation_period_ending
					? mongoDBDateParserToUSAFormat_v2(open_negotiation_period_ending)
					: open_negotiation_period_ending,
				reissued: reissued,
				selection_of_certified_idr_entity: selection_of_certified_idr_entity
					? mongoDBDateParserToUSAFormat_v2(selection_of_certified_idr_entity)
					: selection_of_certified_idr_entity,
				selection_of_offer_and_decision: selection_of_offer_and_decision
					? mongoDBDateParserToUSAFormat_v2(selection_of_offer_and_decision)
					: selection_of_offer_and_decision,
				submission_of_offer: submission_of_offer
					? mongoDBDateParserToUSAFormat_v2(submission_of_offer)
					: submission_of_offer
			});
		});
	};

	const getPaidClaimListAllClaimsMember = useCallback(async (paginationQuery: filterQuery) => {
		// console.log("grop_number", paginationQuery);

		const result = await trackPromise(
			api.paidClaim.getPaidClaims({ ...paginationQuery, is_all_claims: true, claim_status: CLAIM_STATUS.active })
		);
		const { members } = result;
		const _members: any[] = [];
		handleMemberChanges(members, _members);
		setAllClaimsMember(_members);
	}, []);

	const getPaidClaimListCheckStatusRequested = useCallback(async (paginationQuery: any) => {
		const result = await trackPromise(
			api.paidClaim.getPaidClaims({
				...paginationQuery,
				is_check_status_requested: true,
				claim_status: CLAIM_STATUS.active
			})
		);
		const { members } = result;
		const _members: any[] = [];
		handleMemberChanges(members, _members);
		setCheckStatusRequestedMembers(_members);
	}, []);

	const getPaidClaimListClosureLetterCompleted = useCallback(async (paginationQuery: any) => {
		const result = await trackPromise(
			api.paidClaim.getPaidClaims({
				...paginationQuery,
				is_closure_letter_completed: true,
				claim_status: CLAIM_STATUS.active
			})
		);
		const { members } = result;
		const _members: any[] = [];
		handleMemberChanges(members, _members);
		setClousureLetterCompleted(_members);
	}, []);
	const getPaidClaimListClosureLetterRequired = useCallback(
		async (paginationQuery: any) => {
			const result = await trackPromise(
				api.paidClaim.getPaidClaims({
					...paginationQuery,
					is_closure_letter_required: true,
					claim_status: CLAIM_STATUS.active
				})
			);
			const { members } = result;
			const _members: any[] = [];
			handleMemberChanges(members, _members);
			setClousureLetterRequired(_members);
		},
		[group]
	);
	const getMoveToHistory = useCallback(
		async (paginationQuery: any) => {
			const result = await trackPromise(
				api.paidClaim.getPaidClaims({ ...paginationQuery, claim_status: CLAIM_STATUS.expired })
			);
			const { members } = result;
			const _members: any[] = [];
			handleMemberChanges(members, _members);
			setMoveToHistory(_members);
		},
		[group]
	);

	const handleSettingsClick = () => {
		const pathName = "/idr/settings";
		navigate(pathName);
	};

	const getPaidClaimsSorted = useCallback(
		async (page: number) => {
			try {
				if (typeof limit === "number" && typeof group.number === "number") {
					let paginationQuery = {
						limit: 20,
						page: page,
						has_notes: hasNotes,
						group_number: GROUP_LIST[group_index].number,
						field:
							sortField.field === "" ||
							sortField.field === undefined ||
							sortField.order === "" ||
							sortField.order === undefined
								? undefined
								: sortField.field,
						order:
							sortField.field === "" ||
							sortField.field === undefined ||
							sortField.order === "" ||
							sortField.order === undefined
								? undefined
								: sortField.order
					};
					Object.entries(paidClaimFilterSchema).map(([key, value]) => {
						if (value.value !== "" && value.value !== null) {
							paginationQuery = {
								...paginationQuery,
								[key]: value.value
							};
						}
					});

					getPaidClaimListAllClaimsMember(paginationQuery);
					getPaidClaimListCheckStatusRequested(paginationQuery);
					getPaidClaimListClosureLetterCompleted(paginationQuery);
					getPaidClaimListClosureLetterRequired(paginationQuery);
					getMoveToHistory(paginationQuery);
					if (!isPageChange) {
						// console.log("===>search work", isPageChange);
						getPaidClaimCount({ ...pageState, ...paginationQuery, group_number: group.number });
					}
					//console.log(paginationQuery);

					// categoarizeMembers(_members);

					// if (response.data.result) {
					// 	const {
					// 		data: { result }
					// 	} = response;

					// 	// agGridRef.current.api.setRowData(Object.assign([], _members));
					// 	// agGridRef.current.api.refreshCells();
					// 	//setPaidClaims(Object.assign([], _members));
					// 	//agGridAPI?.refreshCells();
					// }
				}
			} catch (err) {
				throw err;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			hasNotes,
			getPaidClaimListAllClaimsMember,
			getPaidClaimListCheckStatusRequested,
			getPaidClaimListClosureLetterCompleted,
			getPaidClaimListClosureLetterRequired,
			getMoveToHistory,
			group.number,
			group_index,
			limit,
			paidClaimFilterSchema,
			sortField.field,
			sortField.order,
			isPageChange
		]
	);
	const getPaidClaimCount = useCallback(
		async (filter: any = {}) => {
			if (limit && limit > 0) {
				const count = await trackPromise(api.paidClaim.countPaidClaims(filter));
				const pageCount = Math.ceil(count / limit);
				// console.log("pageCount", pageCount);
				setPagination(Object.assign({}, pagination, { pageCount }));

				//getPaidClaims(currentPage);
				// getPaidClaimsSorted(pagination.currentPage);
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		},
		[limit]
	);

	// const handleDateCellRenderer = ({ value }: any): any => {
	// 	console.log("value", value);
	// 	//return <div>hi</div>;
	// 	return <div>{value ? (dateTimeZoneConverter(value) as string) : "N/A"}</div>;
	// };

	const handlePageChange = useCallback(
		(event: React.ChangeEvent<unknown>, page: number) => {
			setIsPageChange(true);
			setPagination(
				Object.assign({}, pagination, {
					currentPage: page
				})
			);
			// getPaidClaimsSorted(page);
		},
		[getPaidClaimsSorted, pagination]
	);

	const handleSortChange = useCallback(
		(event: SelectChangeEvent) => {
			const { name, value } = event.target;
			setSortField(
				Object.assign({}, sortField, {
					[name]: value
				})
			);
		},
		[sortField]
	);

	// const handleTextCellRenderer = ({ value }: any) => {
	// 	return <div>{value ? value : "N/A"}</div>;
	// };
	const handleClearRowMp = () => {
		const tempMap = selectedRowMap;
		tempMap.clear();
		setSelectedRowMap(tempMap);
	};

	useEffect(() => {
		setLimit(20);
		getPaidClaimCount({ ...pageState, group_number: group.number });
		handleClearRowMp();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getPaidClaimCount, group, pageState]);

	useEffect(() => {
		handleChnagePageState();
	}, [handleChnagePageState]);

	useEffect(() => {
		//alert(hasClickedSort);
		// console.log("Limit", limit);
		getPaidClaimsSorted(pagination.currentPage);
		setHasClickedSort(false);
		//alert("getSorted")
	}, [
		getPaidClaimsSorted,
		group_index,
		hasClickedSort,
		limit,
		pagination.currentPage,
		sortField.field,
		sortField.order
	]);

	// console.log("selectedRowMap", selectedRowMap);
	// console.log("a11yProps", a11yProps(0));

	return (
		<div className="dashboard">
			{/* <Topbar /> */}
			<div
				style={{
					textAlign: "end",
					marginBottom: "2rem",
					marginTop: "2rem",
					display: "flex",
					justifyContent: "space-between"
				}}
			>
				<div className="logo">
					<img src={GROUP_LIST[group_index].logo} />
				</div>
				<Chip
					onClick={handleClickToAddRecord}
					onDelete={() => null}
					deleteIcon={<AddIcon />}
					label="Add Record"
					variant="outlined"
					color="primary"
				/>
			</div>

			<Paper
				elevation={2}
				className="theme-border-radius benefits-paper-form-container"
				style={{ marginTop: "1.5rem" }}
			>
				<Box sx={{ width: "100%" }}>
					<Box sx={{ borderBottom: "none" }}>
						<Tabs
							value={tabLabel}
							onChange={handleLabelChange}
							TabIndicatorProps={{
								style: {
									border: "none",
									background: "#ab455c"
								}
							}}
							variant="scrollable"
							scrollButtons="auto"
							aria-label="scrollable auto tabs example"
							className="glb-tab-panel"
						>
							<Tab
								label={CATEGORY_LIST.is_all_claims}
								className="glb-tab-label"
								{...a11yProps(0)}
								style={{ fontWeight: "bold", fontSize: "1rem", textTransform: "capitalize" }}
							/>
							<Tab
								label={CATEGORY_LIST.is_check_status_requested}
								className="glb-tab-label"
								{...a11yProps(1)}
								style={{ fontWeight: "bold", fontSize: "1rem", textTransform: "capitalize" }}
							/>
							<Tab
								label={CATEGORY_LIST.is_closure_letter_completed}
								className="glb-tab-label"
								{...a11yProps(2)}
								style={{ fontWeight: "bold", fontSize: "1rem", textTransform: "capitalize" }}
							/>
							<Tab
								label={CATEGORY_LIST.is_closure_letter_required}
								className="glb-tab-label"
								{...a11yProps(3)}
								style={{ fontWeight: "bold", fontSize: "1rem", textTransform: "capitalize" }}
							/>
							<Tab
								label={CATEGORY_LIST.is_move_to_history}
								className="glb-tab-label"
								{...a11yProps(4)}
								style={{ fontWeight: "bold", fontSize: "1rem", textTransform: "capitalize" }}
							/>
							<Tab
								label={"Report Generation"}
								className="glb-tab-label"
								{...a11yProps(5)}
								style={{ fontWeight: "bold", fontSize: "1rem", textTransform: "capitalize" }}
							/>
						</Tabs>
					</Box>

					{/* sort field section */}
					{tabLabel !== 5 ? (
						<SortSection
							sortField={sortField}
							selectedRowMap={selectedRowMap}
							handleUpdateCategory={handleUpdateCategory}
							handleSortChange={handleSortChange}
							setHasClickedSort={setHasClickedSort}
						/>
					) : null}
					{tabLabel !== 5 ? (
						<div className="settingsHistoryButton">
							<div>
								<FormGroup>
									<FormControlLabel
										control={
											<Checkbox
												checked={hasNotes}
												onChange={handleStatusChangeNotes}
												sx={{
													color: pink[800],
													"&.Mui-checked": {
														color: pink[600]
													}
												}}
											/>
										}
										label="Show Only Notes Claims"
									/>
								</FormGroup>
							</div>
							<Button variant="outlined" className="button-blue-light" onClick={handleSettingsClick}>
								<SettingsIcon style={{ marginRight: "4px" }} />
								Settings
							</Button>
						</div>
					) : null}

					<TabPanel value={tabLabel} index={0}>
						<Suspense fallback>
							{/* dashboard ag grid */}
							<DashboardGrid
								state={{ is_all_claims: true, claim_status: CLAIM_STATUS.active, has_notes: hasNotes }}
								group_number={GROUP_LIST[group_index].number}
								selectedRowMap={selectedRowMap}
								handleSelectRow={handleSelectRow}
								paidClaimFilterSchema={paidClaimFilterSchema}
								setPaidClaimFilterSchema={setPaidClaimFilterSchema}
								setPaidClaims={setPaidClaims}
								members={allClaimsMember}
								handleClaimStatus={handleClaimStatus}
							/>
						</Suspense>
					</TabPanel>
					<TabPanel value={tabLabel} index={1}>
						<Suspense fallback>
							{/* dashboard ag grid */}
							<DashboardGrid
								state={{
									is_check_status_requested: true,
									claim_status: CLAIM_STATUS.active,
									has_notes: hasNotes
								}}
								group_number={GROUP_LIST[group_index].number}
								selectedRowMap={selectedRowMap}
								handleSelectRow={handleSelectRow}
								members={checkStatusRequestedMembers}
								paidClaimFilterSchema={paidClaimFilterSchema}
								setPaidClaimFilterSchema={setPaidClaimFilterSchema}
								setPaidClaims={setPaidClaims}
								handleClaimStatus={handleClaimStatus}
							/>
						</Suspense>
					</TabPanel>
					<TabPanel value={tabLabel} index={2}>
						<Suspense fallback>
							{/* dashboard ag grid */}
							<DashboardGrid
								state={{
									is_closure_letter_completed: true,
									claim_status: CLAIM_STATUS.active,
									has_notes: hasNotes
								}}
								group_number={GROUP_LIST[group_index].number}
								selectedRowMap={selectedRowMap}
								handleSelectRow={handleSelectRow}
								members={clousureLetterCompleted}
								paidClaimFilterSchema={paidClaimFilterSchema}
								setPaidClaimFilterSchema={setPaidClaimFilterSchema}
								setPaidClaims={setPaidClaims}
								handleClaimStatus={handleClaimStatus}
							/>
						</Suspense>
					</TabPanel>
					<TabPanel value={tabLabel} index={3}>
						<Suspense fallback>
							{/* dashboard ag grid */}
							<DashboardGrid
								state={{
									is_closure_letter_required: true,
									claim_status: CLAIM_STATUS.active,
									has_notes: hasNotes
								}}
								group_number={GROUP_LIST[group_index].number}
								selectedRowMap={selectedRowMap}
								handleSelectRow={handleSelectRow}
								members={clousureLetterRequired}
								paidClaimFilterSchema={paidClaimFilterSchema}
								setPaidClaimFilterSchema={setPaidClaimFilterSchema}
								setPaidClaims={setPaidClaims}
								handleClaimStatus={handleClaimStatus}
							/>
						</Suspense>
					</TabPanel>
					<TabPanel value={tabLabel} index={4}>
						<Suspense fallback>
							{/* dashboard ag grid */}
							<DashboardGrid
								state={{ claim_status: CLAIM_STATUS.expired, has_notes: hasNotes }}
								group_number={GROUP_LIST[group_index].number}
								selectedRowMap={selectedRowMap}
								handleSelectRow={handleSelectRow}
								members={moveToHistory}
								paidClaimFilterSchema={paidClaimFilterSchema}
								setPaidClaimFilterSchema={setPaidClaimFilterSchema}
								setPaidClaims={setPaidClaims}
								handleClaimStatus={handleClaimStatus}
							/>
						</Suspense>
					</TabPanel>
					<TabPanel value={tabLabel} index={5}>
						<Suspense fallback>
							{/* dashboard ag grid */}
							<ReportGrid group_number={group.number} />
						</Suspense>
					</TabPanel>
				</Box>
			</Paper>

			{/*pagination section*/}
			<div className="custom-pagination" id="custom-pagination">
				{/* <CustomPagination pageCount={pageCount} currentPage={currentPage} handlePageChange={handlePageChange} /> */}
				<div className="custom-pagination-outer-container" id="custom-pagination-outer-container">
					<div className="custom-pagination-inner-container">
						<Pagination
							className="pagination"
							count={pageCount}
							defaultPage={1}
							page={currentPage}
							boundaryCount={2}
							onChange={handlePageChange}
							showFirstButton
							showLastButton
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
